// extracted by mini-css-extract-plugin
module.exports = {"service-page":"ServicePage_service-page___CSgs","servicePage":"ServicePage_service-page___CSgs"};